import adamello_ski from './svg/adamello-ski.svg';
import adamello_ski_b2b from './svg/adamello-ski-b2b.svg';
import adamello_ski_summer from './svg/adamello-ski~summer.svg';
import aprica from './svg/aprica.svg';
import bardonecchia from './svg/bardonecchia.svg';
import bardonecchia_summer from './svg/bardonecchia~summer.svg';
import beneficy from './svg/beneficy.svg';
import beneficy_bikeit from './svg/beneficy-bikeit.svg';
import beneficy_discovera from './svg/beneficy-discovera.svg';
import beneficy_snowit from './svg/beneficy-snowit.svg';
import bikeit from './svg/bikeit.svg';
import bolonice from './svg/bolonice.svg';
import bormioski from './svg/bormioski.svg';
import bormioski_summer from './svg/bormioski~summer.svg';
import cervino_ski from './svg/cervino-ski-paradise.svg';
import cervino_ski_b2b from './svg/cervino-ski-paradise-b2b.svg';
import ciclista from './svg/ciclista.svg';
import cimone from './svg/cimone.svg';
import cornoallescale from './svg/cornoallescale.svg';
import cortina from './svg/cortina.svg';
import courmayeur from './svg/courmayeur.svg';
import discovera from './svg/discovera.svg';
import dovesciare from './svg/dovesciare.svg';
import edenred from './svg/edenred-original.svg';
import endurorepublic from './svg/endurorepublic.svg';
import endurorepublic_hotel from './svg/endurorepublic-hotel.svg';
import folgaria from './svg/folgaria.svg';
import gazzetta_adventure from './svg/gazzettaadventure.svg';
import getyourguide from './svg/getyourguide.svg';
import giteintreno from './svg/giteintreno.svg';
import gks from './svg/gks.svg';
import happyrental from './svg/happyrental.svg';
import jakala_discovera from './svg/jakala-discovera.svg';
import jakala_snowit from './svg/jakala-snowit.svg';
import jointly from './svg/jointly.svg';
import jointly_discovera from './svg/jointly-discovera.svg';
import kiterevolution from './svg/kiterevolution.svg';
import kts from './svg/kts.svg';
import livigno from './svg/livigno.svg';
import livigno_b2b from './svg/livigno-b2b.svg';
import livigno_summer from './svg/livigno~summer.svg';
import madonnadicampiglio_b2b from './svg/madonnadicampiglio-b2b.svg';
import madonnadicampiglio_b2b_agenzie from './svg/madonnadicampiglio-b2b-agenzie.svg';
import mangaclimbing_tribala from './svg/mangaclimbing-tribala.svg';
import mc4season from './svg/mc4season.svg';
import padel4fun from './svg/padel4fun.svg';
import padelacademy from './svg/padelacademy.svg';
import paganella from './svg/paganella.svg';
import pianidibobbio from './svg/pianidibobbio.svg';
import pianidibobbio_b2b from './svg/pianidibobbio-b2b.svg';
import pianidibobbio_summer from './svg/pianidibobbio~summer.svg';
import santacaterina from './svg/santacaterina.svg';
import santacaterina_summer from './svg/santacaterina~summer.svg';
import skifun from './svg/skifun.svg';
import skipasslombardia from './svg/skipasslombardia.svg';
import snowit from './svg/snowit.svg';
import snowit_europe from './svg/snowit-europe.svg';
import snowit_travel from './svg/snowit-travel.svg';
import sportmission from './svg/sportmission.svg';
import tantosvago from './svg/tantosvago.svg';
import tantosvago_bikeit from './svg/tantosvago-bikeit.svg';
import tantosvago_tribala from './svg/tantosvago-tribala.svg';
import tribala from './svg/tribala.svg';
import unipol from './svg/unipol.svg';
import universitybox from './svg/universitybox.svg';
import webshop_fallback from './svg/webshop_fallback.svg';
import xtremelement from './svg/xtremelement.svg';

const svgs = {
  'icon_adamello-ski': adamello_ski,
  'icon_adamello-ski-b2b': adamello_ski_b2b,
  'icon_adamello-ski~summer': adamello_ski_summer,
  'icon_bardonecchia~summer': bardonecchia_summer,
  'icon_beneficy-bikeit': beneficy_bikeit,
  'icon_beneficy-discovera': beneficy_discovera,
  'icon_beneficy-snowit': beneficy_snowit,
  'icon_bormioski~summer': bormioski_summer,
  'icon_cervino-ski-paradise': cervino_ski,
  'icon_cervino-ski-paradise-b2b': cervino_ski_b2b,
  'icon_cornoallescale~summer': cornoallescale,
  'icon_endurorepublic-tribala': endurorepublic,
  'icon_endurorepublic-hotel': endurorepublic_hotel,
  'icon_jakala-discovera': jakala_discovera,
  'icon_jakala-snowit': jakala_snowit,
  'icon_jointly-discovera': jointly_discovera,
  'icon_livigno-b2b': livigno_b2b,
  'icon_livigno~summer': livigno_summer,
  'icon_madonnadicampiglio-b2b': madonnadicampiglio_b2b,
  'icon_madonnadicampiglio-b2b-agenzie': madonnadicampiglio_b2b_agenzie,
  'icon_madonnadicampiglio-gruppi': madonnadicampiglio_b2b,
  'icon_mangaclimbing-tribala': mangaclimbing_tribala,
  'icon_mdc-cambiomerce1': madonnadicampiglio_b2b,
  'icon_mdc-cambiomerce2': madonnadicampiglio_b2b,
  'icon_mdc-coupon': madonnadicampiglio_b2b,
  'icon_pianidibobbio-b2b': pianidibobbio_b2b,
  'icon_pianidibobbio~summer': pianidibobbio_summer,
  'icon_santacaterina~summer': santacaterina_summer,
  'icon_snowit-europe': snowit_europe,
  'icon_snowit-travel': snowit_travel,
  'icon_snowit~summer': snowit,
  'icon_tantosvago-bikeit': tantosvago_bikeit,
  'icon_tantosvago-tribala': tantosvago_tribala,
  icon_aprica: aprica,
  icon_bardonecchia: bardonecchia,
  icon_beneficy: beneficy,
  icon_bikeit: bikeit,
  icon_bolonice: bolonice,
  icon_bormioski: bormioski,
  icon_ciclista: ciclista,
  icon_cimone: cimone,
  icon_cornoallescale: cornoallescale,
  icon_cortina: cortina,
  icon_courmayeur: courmayeur,
  icon_discovera: discovera,
  icon_dovesciare: dovesciare,
  icon_edenred: edenred,
  icon_folgaria: folgaria,
  icon_gazzettaadventure: gazzetta_adventure,
  icon_getyourguide: getyourguide,
  icon_giteintreno: giteintreno,
  icon_gks: gks,
  icon_happyrental: happyrental,
  icon_jointly: jointly,
  icon_kiterevolution: kiterevolution,
  icon_kts: kts,
  icon_livigno: livigno,
  icon_mc4season: mc4season,
  icon_padel4fun: padel4fun,
  icon_padelacademy: padelacademy,
  icon_paganella: paganella,
  icon_pianidibobbio: pianidibobbio,
  icon_santacaterina: santacaterina,
  icon_skifun: skifun,
  icon_skipasslombardia: skipasslombardia,
  icon_snowit: snowit,
  icon_sportmission: sportmission,
  icon_tantosvago: tantosvago,
  icon_tribala: tribala,
  icon_unipol: unipol,
  icon_university_box: universitybox,
  icon_webshop_fallback: webshop_fallback,
  icon_xtremelement: xtremelement,
} as const;

export type SvgTenantsList = keyof typeof svgs;
export default svgs;
